<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import VerificationCode from '@/components/modals/verification-code.vue';
import PurchaseRequests from "@/router/views/procurement/bac/purchase-request";
import AbstractQoutation from "@/router/views/procurement/bac/abstract-of-qoutation";
import { cloneDeep } from "lodash";
import PrLogs from "@/components/modals/pr-logs.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
     page: {
        title: "BAC Office",
    },
    components: {
        Layout,
        PageHeader,
        VerificationCode,
        PurchaseRequests,
        // BidsRfq,
        AbstractQoutation,
        PrLogs,
        AttachmentModal,
        PrintOptions
    },
    data() {
        return {
            title: "BAC Office",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "BAC Office",
                    active: true,
                },
            ],
            selectedItem: null,
            selectedType: {},
            modalTitle: "",
            prDataCount: 0,
            aoqDataCount: 0,
        };
    },
    async mounted(){
        await this.$refs.aoq.getUnits();
        this.$refs.pr.getPendingData();
        this.$refs.aoq.getPendingData();
    },
    methods: {
        approve(data){
            this.selectedItem = cloneDeep(data.row);
            if(data.type === 'pr'){
                this.selectedType = {
                    id: data.row.id,
                    type: 'PR BAC Approval',
                    message: 'You want to approve this BAC Res?',
                    url: 'prresolutionmember/ApproveResolution'
                }
            }else if(data.type === 'aoq'){
                this.selectedType = {
                    id: data.row.id,
                    type: 'AOQ BAC Approval',
                    message: 'You want to approve this Abstract of Quotation?',
                    url: 'rfqbacsetting/ApproveBAC'
                }
            }
            Swal.fire({
                title: "Are you sure?",
                text: this.selectedType.message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("verification/sendCode", {type: this.selectedType.type, id: this.selectedType.id})
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.$bvModal.show('verify-modal')
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        verifyNow(code){
            this.$store
                .dispatch("verification/verifyCode", {
                    code: code,
                    type: this.selectedType.type,
                    referenceId: this.selectedItem.id,
                })
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    await this.$store
                        .dispatch(this.selectedType.url, this.selectedItem.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if(this.selectedType.type === 'PR BAC Approval'){
                                this.$refs.pr.approvedDone(this.selectedItem.id);
                            }
                            if(this.selectedType.type === 'AOQ BAC Approval'){
                                this.$refs.aoq.approvedDone(this.selectedItem.id);
                            }
                            this.showToast("Successfully approved!", "success");
                            this.$bvModal.hide('verify-modal')
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeTab(no){
            if(no == 1){
                this.$refs.pr.getPendingData();
            }else if(no == 2){
                await this.$refs.rfq.getUnits();
                this.$refs.rfq.getPendingData();
            }
            else if(no == 3){
                await this.$refs.aoq.getUnits();
                this.$refs.aoq.getPendingData();
            }
        },
        getPRLogs(id){
            this.$refs.prLogs.getData(id);
            this.$bvModal.show("pr-log-modal");
        },
        supplierUploads(id){
            this.modalTitle = "Supplier Offer Attachments";
            this.$refs.attachmentModal.setUploadOpt({
                type: "RFQ Supplier Item Offer",
                placement: "left",
                folder: "Procurement",
            });
            this.$refs.attachmentModal.getData(id, true);
            this.$bvModal.show("upload-attachment-modal");
        },
        printBacRes(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/BacRes",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printAbstract(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Abstract",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        countPRPending(data){
            this.prDataCount = data;
        },
        countAOQPending(data){
            this.aoqDataCount = data;
        },
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
         <div class="row">
            <div class="col-12">
                <b-tabs
                    nav-class="nav-tabs-custom"
                    content-class="pt-3 pb-3 text-muted"
                >
                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block position-relative">BAC Resolutions
                                <small>
                                    <span
                                        class="
                                            badge
                                            bg-danger
                                            position-absolute
                                            py-1
                                            ms-1
                                        "
                                        style="top: -2px"
                                        v-if="prDataCount > 0"
                                        >{{ prDataCount }}
                                    </span>
                                </small>
                            </span>
                        </template>
                        <PurchaseRequests ref="pr" @approvePr="approve" @getPrLogs="getPRLogs" @printBacRes="printBacRes" @countPending="countPRPending"/>
                    </b-tab>
                    <!-- <b-tab @click="changeTab(2)">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Bids and Quotations</span>
                        </template>
                        <BidsRfq ref="rfq" @approve="approve" />
                    </b-tab> -->
                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block position-relative">Abstract of Quotations
                                <small>
                                    <span
                                        class="
                                            badge
                                            bg-danger
                                            position-absolute
                                            py-1
                                            ms-1
                                        "
                                        style="top: -2px"
                                        v-if="aoqDataCount > 0"
                                        >{{ aoqDataCount }}
                                    </span>
                                </small>
                            </span>
                        </template>
                        <AbstractQoutation ref="aoq" @approveAOQ="approve" @showSupplierUploads="supplierUploads" @printAbstract="printAbstract" @countPending="countAOQPending"/>
                    </b-tab>
                </b-tabs>
            </div>
         </div>
         <VerificationCode @dropCode="verifyNow" ref="verification" />
         <pr-logs ref="prLogs"></pr-logs>
         <attachment-modal
            :wActions="false"
            :title="modalTitle"
            ref="attachmentModal"
        ></attachment-modal>
        <print-options ref="printOpt"></print-options>
    </Layout>
</template>